import * as React from "react";
import {FileResource} from "~/client/resources/fileResource";
import {FriendlyLocalTime} from "shared/FriendlyLocalTime";
import {bytesToMegaBytes} from "areas/storageConversions";
import {OverflowMenu} from "components/Menu";
import {DoBusyTask} from "components/DataBaseComponent/DataBaseComponent";
import BaseComponent from "components/BaseComponent";
import {Callout} from "@octopusdeploy/design-system-components";
import SimpleDataTable from "components/SimpleDataTable";
import repository from "client/repository";
import {DownloadFileDialog} from "~/areas/files/DownloadFileDialog";

class DataTable extends SimpleDataTable<FileResource> {
}

interface Props {
    files: FileResource[];
    doBusyTask: DoBusyTask;
    onFilesChanged?: () => void
}

export class CloudPortalFilesTable extends BaseComponent<Props, never> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        return <>
            <Callout type="warning" title={"Warning"}>
                Note: All Cloud Portal files will be automatically deleted after 7 days.
            </Callout>
            <DataTable
                data={this.props.files}
                onRow={this.buildRow}
                onRowOverflowMenu={(file: FileResource) => this.getOverflowMenu(file)}
                headerColumns={["Name", "Last Modified", "Size In MB"]}
                onEmpty={<div>No files found</div>}
            />
        </>;
    }

    private buildRow = (file: FileResource) => {
        return [
            file.Name,
            <FriendlyLocalTime time={file.LastModified}/>,
            bytesToMegaBytes(file.SizeInBytes)
        ];
    }

    private getDownloadLink = (file: FileResource)=> {
        return <DownloadFileDialog
            title={"Download CloudPortal File"}
            getDownloadUrl={(justification) => repository.Files.getUrlToCloudPortalFileContent(file, justification)}
        />
    }

    private getOverflowMenu = (file: FileResource) => {
        return [
            OverflowMenu.dialogItem("Download", this.getDownloadLink(file)),
            OverflowMenu.deleteItem(
                "Delete",
                "Are you sure you want to delete this Cloud Portal file?",
                () => this.deleteCloudPortalFile(file),
                <>
                    <p>Do you wish to continue?</p>
                </>)
        ];
    }

    private deleteCloudPortalFile = (file: FileResource)=> {
        return this.props.doBusyTask(async () => {
            await repository.Files.deleteCloudPortalFile(file);
            if (this.props.onFilesChanged) {
                this.props.onFilesChanged();
            }
        });
    }
}

export default CloudPortalFilesTable;
